// pico components
import { picoapp } from 'picoapp'
import collectionHeaderLink from '../components/collection-header-link'
import customVideoControls from '../components/custom-video-controls'
import jumpToLink from '../components/jump-to-link'
import kustomerAppToggle from '../components/kustomer-app-toggle'
import openTolstoyWidget from '../components/open-tolstoy-widget'
import productGallery from '../components/product-gallery'
import productOptions from '../components/product-options'
import productCardImage from '../components/product-card-image'
import productBadges from '../components/product-badges'
import scrollTrackSlider from '../components/scroll-track-slider'
import sliderAnimated from '../components/slider-animated'
import stickyATC from '../components/sticky-atc'
import subscriptionDropdown from '../components/subscription-dropdown'
import subscriptionListSelectors from '../components/subscription-selectors'
import skinQuiz from '../components/skin-quiz'

const components = {
  collectionHeaderLink,
  customVideoControls,
  jumpToLink,
  kustomerAppToggle,
  openTolstoyWidget,
  productCardImage,
  productBadges,
  productGallery,
  productOptions,
  scrollTrackSlider,
  sliderAnimated,
  stickyATC,
  subscriptionDropdown,
  subscriptionListSelectors,
  skinQuiz,
}

export default picoapp(components)
